import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ContentSectionHeaderProps {
  icon: ReactNode
  title: string
  className?: string
}

export const ContentSectionHeader = ({ icon, title, className }: ContentSectionHeaderProps) => {
  return (
    <h3 className={cn('flex items-center gap-x-2.5', 'text-2xl font-semibold text-black', className)}>
      {icon}
      {title}
    </h3>
  )
}
